import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getPlatformDictionaryByKey } from 'services/platform-dictionary-service';
import {
  CONNECTORS_DICTIONARY_KEY,
  resolveEnabledConnectorNames,
} from './connectors-dictionary';

/** Connector names that should appear on the Connector tab. Empty while the dictionary loads. */
export const useEnabledConnectorNamesState = () => {
  const query = useQuery({
    queryKey: ['platform-dictionary', CONNECTORS_DICTIONARY_KEY],
    queryFn: () => getPlatformDictionaryByKey(CONNECTORS_DICTIONARY_KEY),
    retry: false,
  });

  const names = useMemo(() => {
    if (query.isPending) return new Set<string>();
    const value = query.isError ? undefined : query.data?.Value;
    return resolveEnabledConnectorNames(value);
  }, [query.isPending, query.isError, query.data]);

  return { names, isPending: query.isPending };
};

export const useEnabledConnectorNames = () => useEnabledConnectorNamesState().names;
